export * from './component'
export * as colors from './colors'
